export enum InputType_Enum {
	'text',
	'number',
	'currency',
	'dob'
}
